// extracted by mini-css-extract-plugin
export default {"text":"Title_text__BGb7+","wiggle":"Title_wiggle__r4e3r"};